export const coupleroom = require("./assets/coupleroom.jpg");
export const Logo = require("./assets/Logo.jpg");
export const line = require("./assets/line3.png");
export const bannerVideo1 = require("./assets/video1.mp4");
export const bannerVideo2 = require("./assets/video2.mp4");
export const bannerVideo3 = require("./assets/video3.mp4");
export const amenities1 = require("./assets/A1.jpg");
export const amenities2 = require("./assets/A2.jpg");
export const amenities3 = require("./assets/A3.jpg");
export const amenities4 = require("./assets/A4.jpg");
export const amenities5 = require("./assets/A5.jpg");
export const amenities6 = require("./assets/A6.jpg");
export const amenities7 = require("./assets/A7.jpg");

export const gallery_room = require("./assets/gallery_room.jpeg");
export const gallery_room2 = require("./assets/gallery_room2.jpeg");
export const gallery_room3 = require("./assets/gallery_room3.jpeg");
export const gallery_swimpool = require("./assets/gallery_swimpool.jpeg");
export const gallery_eagle_video = require("./assets/eagles_villa_video.mp4");

export const near1= require("./assets/N1.jpg");
export const near2= require("./assets/N2.jpg");
export const near3= require("./assets/N3.jpg");
export const near4= require("./assets/N4.jpg");
export const near5= require("./assets/N5.jpg");
export const near6= require("./assets/N6.jpg");
export const near7= require("./assets/N7.jpg");
export const near8= require("./assets/N8.jpg");
